"use client";

import { useSpatiusAvatarContext } from "@/components/spatius-avatar/spatius-avatar-context";
import { cn } from "@/lib/utils";
import type { CSSProperties, HTMLAttributes, MutableRefObject, Ref } from "react";

const SPATIUS_BACKGROUND_IMAGE = "/ui/Background.png";
const SPATIUS_BACKGROUND_POSITION = "center center";
const SPATIUS_BACKGROUND_SIZE = "cover";

function assignRef<T>(ref: Ref<T | null> | undefined, value: T | null) {
  if (typeof ref === "function") {
    ref(value);
    return;
  }

  if (ref) {
    (ref as MutableRefObject<T | null>).current = value;
  }
}

export interface SpatiusAvatarCanvasProps extends HTMLAttributes<HTMLDivElement> {
  minHeight?: CSSProperties["minHeight"];
}

export function SpatiusAvatarCanvas({
  className,
  minHeight = 420,
  ref,
  style,
  ...props
}: SpatiusAvatarCanvasProps & { ref?: Ref<HTMLDivElement> }) {
  const { containerRef } = useSpatiusAvatarContext();

  return (
    <div
      {...props}
      ref={(node) => {
        if (node) {
          containerRef(node);
          assignRef(ref, node);
          return;
        }

        containerRef(null);
        assignRef(ref, node);
      }}
      className={cn("relative z-0 w-full overflow-hidden bg-black", className)}
      style={{
        backgroundImage: `url(${SPATIUS_BACKGROUND_IMAGE})`,
        backgroundPosition: SPATIUS_BACKGROUND_POSITION,
        backgroundRepeat: "no-repeat",
        backgroundSize: SPATIUS_BACKGROUND_SIZE,
        minHeight,
        ...style,
      }}
    />
  );
}
